/** @jsxImportSource @emotion/react */

import "swiper/css";

import { useAppDispatch, useAppSelector } from "hooks/app-hook";
import _isEqual from "lodash/isEqual";
import { useEffect, useRef } from "react";
import { selectUsername } from "store/auth";
import { initialState, selectDataMemberVip } from "store/memberVip";
import { getMemberVip } from "store/memberVip/member.thunk";
import { Swiper as SwiperType } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import VipDetailsItem from "../VipDetailsItem";
import { SwiperVipDetailsStyle } from "./style.index";

const SwiperVipDetails = () => {
  const swiperRef = useRef<SwiperType>();
  const username = useAppSelector(selectUsername);
  const dispatch = useAppDispatch();

  const { data: dataMemberVip } = useAppSelector(selectDataMemberVip);

  const isDataEmptyMemberVip = _isEqual(
    initialState.dataMemberVip.data,
    dataMemberVip,
  );

  useEffect(() => {
    if (!username) return;
    if (!isDataEmptyMemberVip) return;
    dispatch(getMemberVip({ username }));
  }, [username]);

  return (
    <>
      <Swiper
        onBeforeInit={(swiper) => {
          swiperRef.current = swiper;
        }}
        css={SwiperVipDetailsStyle.wrapper}
        slidesPerView={1}
        loop
      >
        {dataMemberVip.board?.map((item, index) => (
          <SwiperSlide key={index}>
            <VipDetailsItem {...item} />
          </SwiperSlide>
        ))}
      </Swiper>
      <div css={SwiperVipDetailsStyle.buttonSwiper}>
        <div
          css={SwiperVipDetailsStyle.btn}
          onClick={() => swiperRef.current?.slidePrev()}
        />
        <div
          css={SwiperVipDetailsStyle.btn}
          onClick={() => swiperRef.current?.slideNext()}
        />
      </div>
    </>
  );
};

export default SwiperVipDetails;
